import { Alert, Modal } from "antd";
import { useGetHolisticsTokenQuery } from "pacts/app-webcore/hasura-webcore.graphql";
import React, { useState } from "react";
import logger from "services/logger/logger";

export type PositionMeasurementsModalProps = {
  visible: boolean;
  onClose: () => void;
  positionId: string;
  positionName?: string;
  locationId: string;
};

// Get the embed ID from environment variable for position measurements
const embedId = process.env.REACT_APP_HOLISTICS_POSITION_MEASUREMENTS_EMBED_ID || "6a516bd5b63ddf3548d3a888";

const PositionMeasurementsModal: React.FC<PositionMeasurementsModalProps> = ({
  visible,
  onClose,
  positionId,
  positionName,
  locationId,
}) => {
  const [holisticsPayload, setHolisticsPayload] = useState<string>("");

  const filters = {
    f1: {
      default_condition: {
        operator: "is",
        values: [positionId],
        modifier: null,
      },
    },
  };

  useGetHolisticsTokenQuery({
    variables: { embedId, locationId, filters: JSON.stringify(filters) },
    onCompleted: (holisticsData) => {
      if (!holisticsData || !holisticsData.getHolisticsToken || holisticsData.getHolisticsToken === "") {
        logger.warn("Position measurements dashboard token is empty for embedId:", embedId);
        return;
      }
      setHolisticsPayload(holisticsData.getHolisticsToken ?? "");
    },
    onError: (error) => {
      logger.error("Error loading position measurements dashboard:", error.message);
    },
    skip: !visible || !embedId || !locationId || !positionId,
  });

  return (
    <Modal
      title={`Zone/Group Measurements${positionName ? ` - ${positionName}` : ""}`}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1200}
      destroyOnClose
      bodyStyle={{ padding: 0, height: "calc(100vh - 55px)" }}
    >
      {!embedId ? (
        <div style={{ padding: 24 }}>
          <Alert
            message="Dashboard Not Configured"
            description="The position measurements dashboard is not configured. Please set the REACT_APP_HOLISTICS_POSITION_MEASUREMENTS_EMBED_ID environment variable."
            type="warning"
            showIcon
          />
        </div>
      ) : (
        <iframe
          title="position measurements dashboard"
          src={`https://secure.holistics.io/embed/${embedId}?_token=${holisticsPayload}`}
          id="embedded-iframe"
          width="100%"
          height="100%"
          className="p-0"
          frameBorder="0"
          allowFullScreen
        />
      )}
    </Modal>
  );
};

export default PositionMeasurementsModal;
